import { render } from "./EntregaGestaoTabela.vue?vue&type=template&id=3b6ad1ea&scoped=true"
import script from "./EntregaGestaoTabela.vue?vue&type=script&lang=js"
export * from "./EntregaGestaoTabela.vue?vue&type=script&lang=js"

import "./EntregaGestaoTabela.vue?vue&type=style&index=0&id=3b6ad1ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6ad1ea"]])

export default __exports__